import { Inject, Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Router } from '@angular/router';
import jQuery from 'jquery';
import { environment } from '../environments/environment';
import { NewRequestService } from './pages/new-request/new-request.service';
import { addRequestList } from './Store/request.actions';
import { Store } from '@ngrx/store';
import * as data from './countries.json';
import { AppConstant } from './app.constants';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { DecimalPipe } from '@angular/common';
import { CommonUtilityService } from './utility/common-utility.service';
import { FormArray, FormGroup } from '@angular/forms';

export interface AddressDetails {
  country?: string;
  subdivision?: string;
  county?: string;
  city?: string;
  neighborhood?: string;
  streetNumber?: string;
  streetName?: string;
  postalCode?: string;
  fullAddress?: string; // New field
}

type ZoomForCountries = {
  [country: string]: number;
};

@Injectable({
  providedIn: 'root'
})
export class SharedService {
  renderer: Renderer2 | undefined;
  public errorMessage: string = '';
  public zoomSize: any;
  public countries: any = (data as any).default;
  public totalTax = 0;
  commaSeparatedAmount: any
  states: any[] = [];
  zoomForCountries: any = {
    'United States': 3,
    'Saint Lucia': 9,
    'Canada': 3,
    'Russia': 3,
    'India': 4,
    'Brazil': 3,
    'United Kingdom': 6,
    'Jamaica': 8,
    'The Bahamas': 7,
    'Cayman Islands': 9,
    'Algeria': 4,
    'Barbados': 9,
    'U.S. Virgin Islands': 11,
    'Saint Kitts & Nevis': 9
  }
  
  countryLogoAvailable = ['jamaica', 'barbados'];
  scriptLoaded$ = new BehaviorSubject<boolean>(false);
  scriptUrl = 'https://app.termly.io/resource-blocker/6e829330-ee66-4cdc-9144-02299d825568?autoBlock=on';
  private progressBarSubject = new BehaviorSubject<boolean>(false);
  progressBar$ = this.progressBarSubject.asObservable();

  private isLoadingSubject = new BehaviorSubject<boolean>(false);
  isLoading$ = this.isLoadingSubject.asObservable();

  constructor(
    private router: Router,
    private requestService: NewRequestService,
    private store: Store,
    @Inject(DOCUMENT) private _document: Document,
    private http: HttpClient,
    public decimalPipe: DecimalPipe,
    rendererFactory: RendererFactory2,
    private commonService: CommonUtilityService
  ) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  setProgressBarState(state: boolean) {
    this.progressBarSubject.next(state);
  }

  setIsLoadingState(state: boolean) {
    this.isLoadingSubject.next(state);
  }

  getZoomForCountry(country: any) {
    if (this.zoomForCountries && this.zoomForCountries[country]) {
      return this.zoomForCountries[country];
    } else {
      return 6;
    }
  }

  public getCountryFromcode = function (country: string) {
    let name = "";
    if (country) {
      let i = this.countries.findIndex(x => x.alpha2.toLowerCase() == country.toLowerCase());
      if (i >= 0) {
        name = this.countries[i].name;
      } else {
        name = country;
      }
    }

    return name;
  }

  performSearch() {
    this.setIsLoadingState(true);
    this.store.dispatch(addRequestList({ requests: [] }));
    const id = localStorage.getItem('brokerId');
    let search_id = localStorage.getItem('search_id');
    const params = JSON.parse(localStorage.getItem('search_params'));
    if (search_id) {
      params['id'] = search_id;
    }
    this.requestService.searchBrokerRequest(id, params).subscribe({
      next: (response: any[]) => {
        this.store.dispatch(addRequestList({ requests: response }));
        this.setIsLoadingState(false);
      },
      error: (error: any) => {
        this.store.dispatch(addRequestList({ requests: [] }));
        this.setIsLoadingState(false);
      }
    })
  }

  checkMatching(request: any, structure: any) {
    return (request == null && structure == null) || request.toString() === structure.toString();
  }

  makeNBI(data: any, status: any) {
    if (!data?.insurable_interest?.length) return { data: [] };
  
    const isPolygonAgent = data?.PricingAdapter?.agentName?.includes('polygon');
  
    const loc_obj = data.insurable_interest.reduce(
      (acc: any, curr: any) => {
  
        // skip if calculations exist
        if (curr?.Calculations != null) return acc;
  
        if (isPolygonAgent) {
  
          const latArr = (curr?.insurableInterestLocationLat || '')
            .split(',')
            .map((s: string) => s.trim())
            .filter(Boolean);
  
          const lngArr = (curr?.insurableInterestLocationLng || '')
            .split(',')
            .map((s: string) => s.trim())
            .filter(Boolean);
  
          /* -------------------- Extra Conditions -------------------- */
  
          // 1️⃣ Must have lat & lng data
          if (!latArr.length || !lngArr.length) return acc;
  
          // 2️⃣ Lat/Lng count must match
          if (latArr.length !== lngArr.length) return acc;
  
          const pairs = latArr.map((lat: string, i: number) => [lat, lngArr[i]]);
  
          // 3️⃣ Minimum 4 points (polygon)
          if (pairs.length < 4) return acc;
  
          // 4️⃣ At least 3 unique points
          const uniquePairs = new Set(pairs.map(p => `${p[0]}_${p[1]}`));
          if (uniquePairs.size < 3) return acc;
  
          // 5️⃣ First & last point must match (closed polygon)
          const [firstLat, firstLng] = pairs[0];
          const [lastLat, lastLng] = pairs[pairs.length - 1];
  
          if (firstLat !== lastLat || firstLng !== lastLng) return acc;
        }
  
        /* -------------------- Push Valid Item -------------------- */
        acc.data.push({
          ...curr,
          locations: [
            {
              insurableInterestLocationLat: curr.insurableInterestLocationLat,
              insurableInterestLocationLng: curr.insurableInterestLocationLng,
              id: curr.id
            }
          ]
        });
  
        return acc;
      },
      { data: [] }
    );
  
    return loc_obj;
  }  

  updateAmount(value: string | number, i?: any): string {
    let cleanValue: string;
    if (value) {
      if (typeof value === 'number') {
        cleanValue = value.toString();
      } else {
        cleanValue = value;
      }
      cleanValue = cleanValue.replace(/[^0-9]/g, '');
      return this.addCommas(cleanValue);
    }
    return '';
  }

  addCommas(value: any): string {
    if (value === null || value === undefined) return '';
  
    const str = String(value); // ensure it's a string
    return str.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }  

  getIntegerPayout(value) {
    return value ? Math.round(value * 100) : value;
  }

  getFloatPayout(value) {
    return value ? (value == 100 ? 1 : (value / 100)) : value;
  }

  getOriginalPayout(value) {
    return value ? (value === 1 ? 100 : value * 100) : value;
  }

  loadDistricts(): Observable<any[]> {
    return new Observable(observer => {
      this.http.get('assets/districts.csv', { responseType: 'text' })
        .subscribe(
          (data: string) => {
            let csvToRowArray = data.split("\n");

            if (csvToRowArray.length < 2) {
              observer.error('CSV data is empty or malformed');
              return;
            }

            const disttricts = [];
            for (let index = 1; index < csvToRowArray.length; index++) {
              let row = csvToRowArray[index].split(",");
              if (row.length < 9) continue;

              let rowData = {
                id: row[0]?.trim(),
                name: row[1]?.trim(),
                country_id: row[2]?.trim(),
                country_code: row[3]?.trim(),
                country_name: row[4]?.trim(),
                state_code: row[5]?.trim(),
                type: row[6]?.trim(),
                latitude: row[7]?.trim(),
                longitude: row[8]?.trim()
              };
              disttricts.push(rowData);
            }

            observer.next(disttricts);
            observer.complete();
          },
          error => {
            observer.error('Error loading CSV: ' + error.message);
          }
        );
    });
  }

  loadStates(): Observable<any[]> {
    return new Observable(observer => {
      this.http.get('assets/states.csv', { responseType: 'text' })
        .subscribe(
          (data: string) => {
            let csvToRowArray = data.split("\n");

            if (csvToRowArray.length < 2) {
              observer.error('CSV data is empty or malformed');
              return;
            }

            const states = [];
            for (let index = 1; index < csvToRowArray.length; index++) {
              let row = csvToRowArray[index].split(",");
              if (row.length < 9) continue;

              let rowData = {
                id: row[0]?.trim(),
                name: row[1]?.trim(),
                country_id: row[2]?.trim(),
                country_code: row[3]?.trim(),
                country_name: row[4]?.trim(),
                state_code: row[5]?.trim(),
                type: row[6]?.trim(),
                latitude: row[7]?.trim(),
                longitude: row[8]?.trim()
              };
              states.push(rowData);
            }

            observer.next(states);
            observer.complete();
          },
          error => {
            observer.error('Error loading CSV: ' + error.message);
          }
        );
    });
  }

  restrictKeys(event: KeyboardEvent): void {
    const allowedKeys = [
      'Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete'
    ];
  
    // Allow control keys
    if (allowedKeys.includes(event.key)) return;
  
    // Allow numbers only (0-9)
    if (/^[0-9]$/.test(event.key)) return;
  
    // Block anything else
    event.preventDefault();
  }

  numberBetweenZeroToHundred(event: any): void {
    const value = Number(event.target.value);
  
    if (value < 0) {
      event.target.value = 0;
    } else if (value > 100) {
      event.target.value = 100;
    }
  }  

  numberOnly(event: KeyboardEvent, type: string = ''): boolean {
    const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'];

    if (allowedKeys.includes(event.key)) {
      return true; // Allow essential keys
    }

    let pattern: RegExp;

    switch (type.toLowerCase()) {
      case 'date':
        pattern = /^[0-9\/-]$/; // Allow numbers and '/' or '-' for date input
        break;
      case 'number':
        pattern = /^[0-9]$/; // Allow only numbers
        break;
      default:
        pattern = /^[0-9]$/; // Default to numeric input
    }

    if (!pattern.test(event.key)) {
      event.preventDefault();
      return false;
    }

    return true;
  }


  numberWithMinus(event: KeyboardEvent, value: string = ''): boolean {
    const allowedKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete'];

    // Allow control/navigation keys
    if (allowedKeys.includes(event.key)) return true;

    // Prevent emoji input
    const isEmoji = /\p{Extended_Pictographic}/u.test(event.key);
    if (isEmoji) {
      event.preventDefault();
      return false;
    }

    // Allow numbers (0-9)
    if (/^\d$/.test(event.key)) return true;

    // Allow '-' only at the beginning and not repeated
    if (event.key === '-') {
      const input = event.target as HTMLInputElement;
      const cursorPos = input.selectionStart ?? 0;

      if (!value.includes('-') && cursorPos === 0) return true;
      return false;
    }

    // Allow '.' only if not already present and not first character
    if (event.key === '.' && !value.includes('.') && value !== '-' && value.length > 0) {
      return true;
    }

    // Otherwise, block input
    return false;
  }

  alphanumericOnly(event: KeyboardEvent, name = ''): boolean {
    const allowedKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete'];

    if (allowedKeys.includes(event.key)) return true;

    const inputElement = event.target as HTMLInputElement;
    const currentValue = inputElement.value;

    const isEmoji = /\p{Extended_Pictographic}/u.test(event.key);
    if (isEmoji) {
      event.preventDefault();
      return false;
    }

    if (event.key === ' ') {
      // Prevent space at the start or consecutive spaces
      if (currentValue.length === 0 || currentValue.endsWith(' ')) {
        event.preventDefault();
        return false;
      }
      return true;
    }

    const isAllowedChar = /^[a-zA-Z0-9\-.,@_!#$%&*()+`~='"/]$/.test(event.key);

    if (!isAllowedChar) {
      event.preventDefault();
      return false;
    }

    return true;
  }

  removeEmojis(value: string, name = ''): string {
    if (!value || typeof value !== 'string') return '';

    // Remove emojis
    value = value.replace(/\p{Extended_Pictographic}+/gu, '');

    if (name === 'lat' || name === 'lng') {
      // Allow digits, one optional leading minus, and one dot
      value = value.replace(/[^0-9.\-]/g, '');

      // Match optional leading minus, followed by digits, optional decimal part
      const match = value.match(/^-$|^-?\d+(\.\d*)?$/);
      return match ? match[0] : '';
    }

    // For general input: keep all characters except emojis (already removed above)
    // Optional: collapse multiple spaces into one
    return value.replace(/ {2,}/g, ' ');
  }


  blockSpaceAndSpecialKeys(event: KeyboardEvent) {
    const forbiddenKeys = [' '];

    if (forbiddenKeys.includes(event.key)) {
      event.stopPropagation();
    }
  }

  isValueZeroLimit(iiVal: any[], page = ''): boolean {
    const isMainPage = page === '';
  
    for (let i = 0; i < iiVal.length; i++) {
      const item = iiVal[i];
      const indexText = ` at Insurable Interest ${i + 1}.`;
  
      const checks = isMainPage
        ? [
            { value: item.insuredRiskFactorValue, label: 'Exposure Value' },
            { value: item.propertyInsuredValue, label: 'Property Insured Value' }
          ]
        : [
            { value: item.reinsuranceExposureValue, label: 'Exposure Value' },
          ];
  
      for (const { value, label } of checks) {
        if (value !== undefined && value !== null && value !== '') {
          if (Number(value) === 0) {
            const suffix = isMainPage ? indexText : ' at Insurer.';
            this.commonService.showSnackbar(`${label} cannot be 0${suffix}`);
            return false;
          }
        }
      }
    }
    return true;
  }  

  isPremiumZero(value: any): boolean {
    if (+value === 0 && value) {
      this.commonService.showSnackbar(`Premium Budget cannot be 0 at Contract Type.`);
      return false;
    }
    return true;
  }

  hasOnlySpacesOrSpecialChars(
    formGroup: FormGroup | FormArray,
    formatFieldLabel?: (field: string) => string,
    parentKey: string = ''
  ): boolean {
    let allFieldsValid = true;

    if (formGroup instanceof FormGroup) {
      for (const key of Object.keys(formGroup.controls)) {
        const control = formGroup.get(key);
        const fullKey = parentKey ? `${parentKey}.${key}` : key;

        if (control instanceof FormGroup || control instanceof FormArray) {
          if (!this.hasOnlySpacesOrSpecialChars(control, formatFieldLabel, fullKey)) {
            allFieldsValid = false;
          }
        } else {
          const value = control?.value;

          // ✅ Skip null, undefined, or empty string values
          if (value == null || value === '') {
            continue;
          }

          if (typeof value === 'string') {
            const trimmed = value.trim();
            let label = formatFieldLabel ? formatFieldLabel(fullKey) : fullKey;

            // 🔁 Replace "Street No" with "Address line"
            label = label.replace(/Street\s*No/gi, 'Address line');
            label = label.replace(/Org/gi, 'Organization');

            if (trimmed === '') {
              this.commonService.showSnackbar(`${label} must not contain only spaces.`);
              allFieldsValid = false;
            } else if (/^[^a-zA-Z0-9]+$/.test(trimmed)) {
              this.commonService.showSnackbar(`${label} must not contain only special characters.`);
              allFieldsValid = false;
            } else if (
              /(org|name|firstname|familyname|city|company\s*name)/i.test(key) &&
              /^\d+$/.test(trimmed)
            ) {
              this.commonService.showSnackbar(`${label} must not contain only numbers.`);
              allFieldsValid = false;
            } else if (
              /(org|name|firstname|familyname|city|company\s*name)/i.test(key) &&
              !/[a-zA-Z]/.test(trimmed)
            ) {
              this.commonService.showSnackbar(`${label} must contain at least one alphabet character.`);
              allFieldsValid = false;
            }

          }
        }
      }
    }

    if (formGroup instanceof FormArray) {
      for (let index = 0; index < formGroup.controls.length; index++) {
        const control = formGroup.at(index);
        const fullKey = `${parentKey}[${index}]`;

        if (control instanceof FormGroup || control instanceof FormArray) {
          if (!this.hasOnlySpacesOrSpecialChars(control, formatFieldLabel, fullKey)) {
            allFieldsValid = false;
          }
        }
      }
    }

    return allFieldsValid;
  }

  getLocationFromPlaceId(placeId: string): Promise<{ lat: number; lng: number } | null> {
    const apiKey = environment.gmap_key;
    const url = `https://maps.googleapis.com/maps/api/place/details/json?place_id=${placeId}&key=${apiKey}`;

    return fetch(url)
      .then(res => res.json())
      .then(data => {
        const result = data.result;
        if (!result || !result.geometry?.location) return null;
        const { lat, lng } = result.geometry.location;
        return { lat, lng };
      })
      .catch(err => {
        console.error('Place ID fetch error:', err);
        return null;
      });
  }

  geocodePlaceName(query: string): Promise<{ lat: number; lng: number } | null> {
    const apiKey = environment.gmap_key; // 🔒 Secure this in environment
    const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(query)}&key=${apiKey}`;

    return fetch(url)
      .then(res => res.json())
      .then(data => {
        const result = data.results?.[0];
        if (!result) return null;
        const { lat, lng } = result.geometry.location;
        return { lat, lng };
      })
      .catch(err => {
        return null;
      });
  }
  reverseGeocode(lat: number, lng: number): Promise<{
    country: string;
    state?: string;
    county?: string;
  } | null> {
    const apiKey = environment.gmap_key;
    const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${apiKey}`;

    return fetch(url)
      .then(res => res.json())
      .then(data => {
        const result = data.results?.[0];
        if (!result) return null;

        let country = '';
        let state = '';
        let county = '';

        for (const component of result.address_components) {
          const types = component.types;
          if (types.includes('country')) country = component.short_name;
          if (types.includes('administrative_area_level_1')) state = component.long_name;
          if (types.includes('administrative_area_level_2')) county = component.long_name;
        }

        return { country, state, county };
      })
      .catch(err => {
        console.error('Reverse geocoding error:', err);
        return null;
      });
  }

  onMapUrlInput(inputRef: HTMLInputElement) {
    const inputValue = inputRef.value || '';
    if (inputValue !== "") {

      const parts = inputValue.split('https://www.google.com/maps').filter(Boolean);

      if (parts.length > 0) {
        const lastUrl = 'https://www.google.com/maps' + parts[parts.length - 1].trim();

        inputRef.value = lastUrl;
      } else {
        inputRef.value = '';
        this.commonService.showSnackbar('Please enter a valid Google Maps URL.');
      }
    }
  }

  removeValueFromLocalStorage() {
    localStorage.removeItem('adapterParams');
    localStorage.removeItem('calculatedValues');
    localStorage.removeItem('categories');
    localStorage.removeItem('type');
    localStorage.removeItem('thresholdStart');
    localStorage.removeItem('thresholdEnd');
    localStorage.removeItem('premiumGross');
    localStorage.removeItem('dataSource');
    localStorage.removeItem('premiumCurrencySymbol')
    localStorage.removeItem('myFormData')
    localStorage.removeItem('name')
    localStorage.removeItem('lastValue')
    localStorage.removeItem('isSimpsonSelected')
  }

  enterValueMin10Max100(event: any) {
    const input = event.target;
    const rawValue = input.value;
  
    const value = parseInt(rawValue, 10);
    const min = 10;
    const max = 100;
  
    if (isNaN(value)) {
      // Optionally reset or ignore empty/invalid input
      input.value = min; // or "", or keep as is
      event.target.dispatchEvent(new Event('input'));
      return;
    }
  
    if (value < min) {
      input.value = min;
      event.target.dispatchEvent(new Event('input'));
    } else if (value > max) {
      input.value = max;
      event.target.dispatchEvent(new Event('input'));
    }
  }  

  blockDotAndMinus(event: KeyboardEvent) {
    const invalidChars = ['-', '.'];
  
    if (invalidChars.includes(event.key)) {
      event.preventDefault();
    }
  }  

  removeEnclosingQuotes(str) {
    if (
      (str?.startsWith('"') && str?.endsWith('"')) ||
      (str?.startsWith("'") && str?.endsWith("'"))
    ) {
      return str?.slice(1, -1);
    }
    return str;
  }
}